import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // localStorage instead of sessionStorage
import rootReducer from './features/rootReducer';
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import { storeAccessor } from './api/storeAccessor';

const persistConfig = {
  key: 'root',
  storage: storage, // Use localStorage for cross-tab persistence
  blacklist: ['auth', 'replay', 'automationStudio', 'automationStudioNew'], // Exclude the 'auth' reducer from persistence
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

// Initialize store accessor for modules that need store access without circular dependencies
storeAccessor.initialize(store);

const persistor = persistStore(store);

export { store, persistor };
